import React from "react";
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
} from "@tanstack/react-query";
import Initialize from "./initialize";
import { ProvidersList } from "react-principal";
import { storeproviders } from "./storeProviders";
import { AppContainer } from "./appcontainer";

const App: React.FC = () => {
  const { data: providers = [] } = useQuery({
    queryKey: ["providers"],
    queryFn: storeproviders,
  });
  console.log({ providers });
  const isShowSplash = !providers.length;
  console.log(Boolean(AppContainer), AppContainer, "container");
  return (
    <>
      {Boolean(providers.length) && (
        <ProvidersList providers={providers}>
          <Initialize>
            {() => (!isShowSplash ? <AppContainer /> : null)}
          </Initialize>
        </ProvidersList>
      )}
      {isShowSplash && <></>}
    </>
  );
};

const AppContainers = () => {
  const client = new QueryClient();
  return (
    <QueryClientProvider client={client}>
      <App />
    </QueryClientProvider>
  );
};

export { AppContainers as App };
